<template>
    <section class="odocs-spaced">
        <p>
            <o-button label="Small" size="small" />
            <o-button label="Default" />
            <o-button label="Medium" size="medium" />
            <o-button label="Large" size="large" />
        </p>
    </section>
</template>
